import { c as _c } from "react/compiler-runtime";
import { Heading, LayoutStack } from 'design-system/client';
import { useTranslations } from 'next-intl';
import AttributionModal from '../AttributionModal';
import DonateButton from '../DonateButton';
import styles from './BottomCallToAction.module.css';
function ShareSection(t0) {
  const $ = _c(13);
  const {
    donationFormUrl,
    fundraisingEventId
  } = t0;
  const t = useTranslations("nextjs");
  let t1;
  if ($[0] !== t) {
    t1 = t("receiver_pages.fundraising_event.do_you_like_cta");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <Heading level="heading-sm" as="h2" className={styles.heading}>{t1}</Heading>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== donationFormUrl || $[5] !== fundraisingEventId) {
    t3 = <DonateButton donationFormUrl={donationFormUrl} fundraisingEventId={fundraisingEventId} buttonLocation="FunE Share" />;
    $[4] = donationFormUrl;
    $[5] = fundraisingEventId;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <AttributionModal id="bottom-call-to-action-attribution-modal" />;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3) {
    t5 = <LayoutStack className={styles.donateButtonContainer}>{t3}{t4}</LayoutStack>;
    $[8] = t3;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t2 || $[11] !== t5) {
    t6 = <div className={styles.outerContainer}><LayoutStack className={styles.container} space="500" as="section"><LayoutStack space="400">{t2}{t5}</LayoutStack></LayoutStack></div>;
    $[10] = t2;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}
export default ShareSection;